<script lang="ts">
  import Button from '$lib/components/shadcn/button/button.svelte'
  import ButtonArrowUpSvg from './SVGs/ButtonArrowUpSVG.svelte'
  import { innerWidth } from 'svelte/reactivity/window'
</script>

<Button
  href="/app"
  class="button-gradient mx-auto mt-[26px] flex h-[46px] w-[175px] items-center justify-evenly rounded-[100px] shadow-sm shadow-[#939EB8] transition-all duration-300 hover:scale-[1.01] active:scale-[.99]"
>
  <p class="text-center font-graphik text-sm font-normal">LAUNCH APP</p>
  <ButtonArrowUpSvg svgStyles="h-[30px] w-[30px]" fillStyles="black" />
</Button>

<style lang="postcss">
  :global(.button-gradient) {
    background: var(--gradient-launch);
    @apply text-black;
  }
</style>
